import * as React from 'react';

import { Wizard } from '@common/components/wizard/_components/wizard.component';

import { AddressNFinances } from 'src/vendor/_components/flows/steps/address-n-finances/address-n-finances.container';
import { CoverageNLimits } from 'src/vendor/_components/flows/steps/coverage-n-limits/coverage-n-limits.container';
import { GeneralInfo } from 'src/vendor/_components/flows/steps/general-info/general-info.container';
import { ReviewStep } from 'src/vendor/_components/flows/steps/review/review-step.container';
import { RouteDefinitions } from '../../../../common/route-definitions';

export interface VendorCreateComponentProperties {
  readonly clearVendorFull: () => void;
}

export class VendorCreateComponent extends React.Component<VendorCreateComponentProperties> {
  public componentWillMount() {
    this.props.clearVendorFull();
  }
  public componentWillUnmount() {
    this.props.clearVendorFull();
  }

  public render(): JSX.Element {
    const steps = [
      { name: 'General Info', component: GeneralInfo },
      { name: 'Address & Finances', component: AddressNFinances },
      { name: 'Coverage & Limits', component: CoverageNLimits },
      { name: 'Review', component: ReviewStep }
    ];

    return <Wizard steps={steps} cancelRoute={RouteDefinitions.vendor.Search} />;
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/vendor-create/vendor-create.component.tsx